import type { LayerListEntry } from '@/core/components/common/layer-list';

/**
 * Waits until a layer path has 0 elements before changing the selection.
 *
 * Used by the Details-Panel and the GeoChart-Panel as a bypass mechanism
 * to ensure layer selection only changes when a layer genuinely has no features.
 *
 * @param mapId - The map identifier
 * @param callbackSetStoreLayerDataArrayBatch - Callback executed when setting the layerPath to be used by the bypass
 * @param callbackSetStoreSelectedLayerPath - Callback executed when selecting a layer based on its layerPath
 * @param memoLayerSelectedItem - The selected item LayerListEntry
 * @param memoLayersList - The list of layers available for selection
 */
export function checkSelectedLayerPathList(
  callbackSetStoreLayerDataArrayBatch: (layerPath: string) => void,
  callbackSetStoreSelectedLayerPath: (layerPath: string) => void,
  memoLayerSelectedItem: LayerListEntry | undefined,
  memoLayersList: LayerListEntry[]
): void {
  // Check if the layer we are on is not 'processed' or 'error', ignore if so
  if (memoLayerSelectedItem && !(memoLayerSelectedItem.queryStatus === 'processed' || memoLayerSelectedItem.queryStatus === 'error'))
    return;

  // Check if the layer we are on still have features
  if (memoLayerSelectedItem?.numOffeatures) {
    // All good, keep selection
    // Reset the bypass for next time
    callbackSetStoreLayerDataArrayBatch(memoLayerSelectedItem.layerPath);
  } else {
    // Find the first layer with features
    const anotherLayerEntry = memoLayersList.find((layer) => {
      return memoLayersList.find((layer2) => layer.layerPath === layer2.layerPath && layer2.numOffeatures);
    });

    // If found
    if (anotherLayerEntry) {
      // Select that one
      callbackSetStoreSelectedLayerPath(anotherLayerEntry.layerPath);
    } else {
      // TODO: INVESTIGATE - Infinite loop in AppBar for statement. (Not sure if still relevant to check or how to check it?)
      // None found, select none
      callbackSetStoreSelectedLayerPath('');
    }
  }
}
